import { render, staticRenderFns } from "./PubliftAdController.vue?vue&type=template&id=13a8f58d&lang=pug&"
import script from "./PubliftAdController.vue?vue&type=script&lang=js&"
export * from "./PubliftAdController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports